import IconBase from "./IconBase";

const PadlockOpenSmoothIcon = props => (
  <IconBase data-testid="PadlockOpenSmoothIcon" {...props}>
    <g fill="none">
      <rect
        stroke="currentColor"
        strokeWidth="2"
        x="4"
        y="9"
        width="12"
        height="8"
        rx="3"
      />
      <circle fill="currentColor" fillRule="evenodd" cx="10" cy="13" r="1" />
      <path
        d="M3 5c.432-1.126 1.722-2 3-2a3 3 0 0 1 3 3v3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </IconBase>
);

export default PadlockOpenSmoothIcon;
